import { ScrollView, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import LottieView from 'lottie-react-native'

import { colors } from '../../theme'
import { quote1 } from '../../theme/typography'
import { Button } from './Button'

const LOTTIE_SIZE = 110

type CompletionScreenProps = Readonly<{
  buttonLabel: string
  heading: string
  isLoading?: boolean
  onPress: () => void
  subheading: string
}>

export function CompletionScreen({
  buttonLabel,
  heading,
  isLoading = false,
  onPress,
  subheading,
}: CompletionScreenProps) {
  const insets = useSafeAreaInsets()
  const bottomPadding = Math.max(insets.bottom, 24)

  return (
    <View
      className="flex-1 bg-background-primary"
      style={{
        paddingTop: insets.top,
        paddingLeft: insets.left,
        paddingRight: insets.right,
      }}
    >
      <ScrollView
        className="flex-1"
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: 'flex-start',
          paddingTop: 24,
        }}
        contentInset={{ bottom: bottomPadding }}
        showsVerticalScrollIndicator={false}
        bounces={false}
      >
        <View className="px-8 flex-1">
          <View className="flex-1 items-center justify-center">
            <View
              className="items-center justify-center overflow-hidden"
              style={{ width: LOTTIE_SIZE, height: LOTTIE_SIZE }}
            >
              <LottieView
                source={require('../../../assets/lottie/check-animation.json')}
                autoPlay
                loop
                style={{ width: LOTTIE_SIZE, height: LOTTIE_SIZE }}
                webStyle={{ width: LOTTIE_SIZE, height: LOTTIE_SIZE }}
              />
            </View>

            <Text
              className="text-ink text-center mt-6"
              style={[quote1, { color: colors.ink }]}
            >
              {heading}
              {'\n'}
              {subheading}
            </Text>
          </View>

          <Button
            label={buttonLabel}
            onPress={onPress}
            variant="primary"
            size="xl"
            loading={isLoading}
            containerClassName="w-full"
          />
          <View style={{ height: bottomPadding }} />
        </View>
      </ScrollView>
    </View>
  )
}
